import { WarningAmberRounded } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { differenceInDays, format, isAfter } from "date-fns";
import KeyNumber from "./KeyNumber";
import { FC } from "react";
import { Status } from "../../../types/inventoryData";
import { useInventory } from "../InventoryProvider";
import { useTranslation } from "react-i18next";

type KeyNumberContainerTypes = {
  popupToggles: {
    history: boolean;
    addProduct: boolean;
    batchEdit: boolean;
    ganttChart: boolean;
    batchQrScannerToggle: boolean;
    batchEditMode: boolean;
  };
  setPopupToggles: React.Dispatch<
    React.SetStateAction<{
      history: boolean;
      addProduct: boolean;
      batchEdit: boolean;
      ganttChart: boolean;
      batchQrScannerToggle: boolean;
      batchEditMode: boolean;
    }>
  >;
};

const KeyNumberContainer: FC<KeyNumberContainerTypes> = ({
  popupToggles,
  setPopupToggles,
}) => {
  const { rows, plans, statusCounts } = useInventory();
  const { t } = useTranslation();

  const calcNextDelivery = () => {
    const nextPlan = plans.find((p) => {
      return isAfter(new Date(p.startDate), Date.now());
    });
    if (nextPlan != undefined) {
      const days = differenceInDays(new Date(nextPlan.startDate), Date.now());
      return `${t("inventory.nextDelivery")} - ${days} ${t("inventory.days")}`;
    } else {
      return `No Delivery`;
    }
  };

  const calcDaysToNextDelivery = () => {
    const nextPlan = plans.find((p) => {
      return isAfter(new Date(p.startDate), Date.now());
    });
    if (nextPlan != undefined) {
      return `${format(new Date(nextPlan.startDate), "dd-MM-yyy")}: ${
        nextPlan.companyName
      }`;
    } else {
      return "-";
    }
  };

  return (
    <Grid
      container
      rowSpacing={2}
      columnSpacing={2}
      // columns={{ xs: 4, md: 12 }}
    >
      <Grid item container sm={12} md spacing={2}>
        <KeyNumber
          title={t("inventory.totalItems")}
          value={rows.length}
          handleHistoryPopup={() =>
            setPopupToggles({ ...popupToggles, history: true })
          }
        />

        <KeyNumber
          title={calcNextDelivery()}
          value={calcDaysToNextDelivery()}
          handleHistoryPopup={() =>
            setPopupToggles({ ...popupToggles, history: true })
          }
          historyButton={false}
        />
      </Grid>

      <KeyNumber
        title={"Available"}
        value={statusCounts[Status.Available]}
        handleHistoryPopup={() =>
          setPopupToggles({ ...popupToggles, history: true })
        }
        icon={<WarningAmberRounded sx={{ color: "red", fontSize: 20 }} />}
      />

      <KeyNumber
        title={"In Use"}
        value={statusCounts[Status.InUse]}
        handleHistoryPopup={() =>
          setPopupToggles({ ...popupToggles, history: true })
        }
      />

      <KeyNumber
        title={"QA"}
        value={statusCounts[Status.QA]}
        handleHistoryPopup={() =>
          setPopupToggles({ ...popupToggles, history: true })
        }
      />

      <KeyNumber
        title={"Defect"}
        value={statusCounts[Status.Defect]}
        handleHistoryPopup={() =>
          setPopupToggles({ ...popupToggles, history: true })
        }
      />
    </Grid>
  );
};

export default KeyNumberContainer;
